<template>
  <!--falta modificar-->
  <div>
    <li class="list-group-item pt-1 pb-2">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 mb-1">

          <h3 class="d-inline">
            <slot class="d-inline"> Módulo {{ index + 1 }}: </slot>
            <input class="form-control d-inline input-module" v-model="namemodule" />
            <button class="btn btn-outline-primary p-0 btn-size" @click="editModule">
              Editar
            </button>
            <button class="btn btn-outline-danger p-0 btn-size" @click="deleteModule(module)">
              Eliminar
            </button>
          </h3>

          <div class="float-right">
            <button class="btn btn-outline-secondary p-0 btn-size" @click="addClass(module)">            
              Clase
            </button>
          </div>

        </div>
      </div>

      <!-- Class List -->
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <ol class="list-group">
            <course-module-class
              @deleteClass="classData"
              @editClass="classModal"
              v-for="(clas, index) in classes"
              :key="clas.id"
              :module="module"
              :observations="observations"
              :clas="clas"
            >
              {{ index + 1 }}
            </course-module-class>
          </ol>
        </div>
      </div>
    </li>
  </div>
</template>

<script>
import api from '../../../api/api';
import CourseModuelClass from './classes/CourseModuleClass.vue';
// import { SaveIcon,Trash2Icon, PlusSquareIcon } from 'vue-feather-icons'

export default {
  props: {
    module: {
      type: Object,
      required: true,
    },
    course: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  components: {
    'course-module-class': CourseModuelClass,
    // SaveIcon,
    // Trash2Icon,
    // PlusSquareIcon,
  },
  data() {
    return {
      name: '',
      classes: [],
      observations: [],
      edit: false,
      namemodule: this.module.name,
    };
  },

  mounted() {
    this.listClasses();
    // this.listObservations();
  },
  watch:{
    module: function(){
      this.listClasses();
    }
  },

  methods: {
    deleteModule(moduleSelected) {
      this.$emit('delete', moduleSelected);
    },

    addClass(moduleSelected) {
      this.$emit('addClass', moduleSelected);
    },

    classData(classSelected) {
      this.$emit('deleteClass', classSelected);
    },

    classModal(classSelected) {
      this.$emit('editClass', classSelected);
    },

    hasEspecialCharacters(text) {
      const regex = new RegExp(/^[A-Za-z0-9\s\u00f1\u00d1-áéíóúÁÉÍÓÚ]+$/g);
      return regex.test(text);
    },
    validateFields() {
      if (!this.namemodule || this.namemodule.trim() === '' || this.namemodule.length === 0) {
        this.$message.warning('Titulo esta vacio!');
        return false;
      }
      if (this.namemodule.length > 255) {
        this.$message.warning('Titulo demasiado largo!');
        return false;
      }
      // if (!this.hasEspecialCharacters(this.namemodule)) {
      //   this.$message.warning('El título no puede contener caracteres especiales');
      //   return false;
      // }
      return true;
    },

    editModule() {
      if (this.validateFields()) {
        axios.put(`/productos/module/${this.module.id}/update`, {
            name: this.namemodule,
          })
          .then((response) => {
            this.module.name = response;
            this.$message.success('Módulo modificado correctamente');
          });
      }
    },

    listClasses() {
      axios.get(`/productos/module/class/${this.module.id}/classList`)
        .then((response) => {
          this.classes = response.data;
          // console.log(this.classes);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // listObservations() {
    //     axios.get(`/productos/module/class/${this.course.id}/listObservations`)
    //     .then((response) => {
    //       this.observations = response;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
  },
};//750px
</script>
<style>
.input-module{
  width: 40%;
}
.btn-size{
  width: 80px; 
  height: 40px;
}
@media (max-width: 800px) {
  .input-module{
    width: 100%;
    margin: 10px 0px;
  }
  .btn-size{
    width: 80px; 
    height: 40px;
  }
}
</style>
